import { InputLabel } from '@mui/material'

export default InputLabel
